export const assembleHelp = (theme) => ({
    container: {
        display: "flex",
        minHeight: 114,
        background: theme.customPalette.neutralGr02,
        width: 1160,
        padding: "32px 40px",
        marginLeft: "auto",
        marginRight: "auto",
        "@media (min-width: 501px) and (max-width: 1208px)": {
            width: "auto",
            padding: 16,
            marginLeft: 24,
            marginRight: 24,
        },
        "@media (max-width: 500px)": {
            width: "auto",
            padding: 16,
            marginLeft: 16,
            marginRight: 16,
        },
    },
    content: {
        display: "flex",
        alignSelf: "center",
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
    },
    titleContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexGrow: 2,
    },
    actionContainer: {
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center",
        flexGrow: 1,
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            width: "100%",
        },
    },
    title: {
        fontWeight: "bold",
        fontSize: 24,
        marginLeft: 40,
        [theme.breakpoints.down("sm")]: {
            marginLeft: 16,
        },
    },
    cancelButtonWrapper: {
        marginLeft: 40,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            marginLeft: 0,
            marginRight: 0,
            flexGrow: "1",
        },
    },
    image: {
        width: 56,
        height: 56,
    },
    button: {
        width: 220,
        minHeight: 48,
        [theme.breakpoints.down("sm")]: {
            marginTop: 32,
            marginBottom: 32,
            width: "100%",
        },
    },
    buttonAlone: {
        width: 220,
        minHeight: 48,
        [theme.breakpoints.down("sm")]: {
            marginTop: 32,
            marginBottom: 0,
            width: "100%",
        },
    },
    cancelButton: {
        whiteSpace: "nowrap",
    },
});
